{
  "open": "Открыть чат",
  "unread_one": "{count} непрочитанное сообщение",
  "unread_few": "{count} непрочитанных сообщения",
  "unread_many": "{count} непрочитанных сообщений",
  "unread_other": "{count} непрочитанного сообщения",
  "close": "Закрыть"
}
